import { documentationActions } from '../../actions/constant';
const {
  REQUEST_LOADING_DOCUMENTATION,
  SUCCESS_LOADING_DOCUMENTATION,
  RESET_LOADING_DOCUMENTATION,
  ERROR_LOADING_DOCUMENTATION,
} = documentationActions;

const intitialstate: object = {
  response: null,
  loader: false,
  error: false,
};

export const loaderDocumenattionReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case REQUEST_LOADING_DOCUMENTATION: {
      return {
        ...state,
        loader: true,
        response: action.payload,
        error: false,
      };
    }

    case SUCCESS_LOADING_DOCUMENTATION:
      return {
        loader: false,
        response: action.payload,
        error: false,
      };

    case ERROR_LOADING_DOCUMENTATION:
      return {
        loader: false,
        response: action.payload,
        error: true,
      };

    case RESET_LOADING_DOCUMENTATION:
      return intitialstate;

    default:
      return state;
  }
};
